jQuery( $ => {
	$( '.faq-category-anchor' ).click( function( e ) {
		e.preventDefault();
		const target = $( $( this ).attr( 'href' ) );

		// Bail if for some reason we cant find the target.
		if ( 0 >= target.length ) {
			return;
		}

		// Animate scrollposition to the target.
		$( 'html, body' ).animate( {
			scrollTop: target.offset().top - $( '.site-header' ).height(),
		}, 400 );
	} );
} );
